export default __webpack_public_path__ + "static/media/img3pro8.a7797e70.jpeg";